import { createContext,useContext,useEffect,useState,useCallback } from "react";

const AuthContext=createContext(null);

const getCookie=(name)=>{
  const value=document.cookie.split("; ").find((row)=>row.startsWith(`${name}=`));
  return value?decodeURIComponent(value.split("=")[1]):"";
};

export function AuthProvider({ children }){
  const [user,setUser]=useState(null);
  const [loading,setLoading]=useState(true);

  const getCsrf=useCallback(async()=>{
    const res=await fetch("/csrf/",{credentials:"include"});
    if(!res.ok) throw new Error("No se pudo obtener la protección CSRF");
    const data=await res.json();
    return data.csrfToken;
  },[]);

  const refresh=useCallback(async()=>{
    try{
      const csrf=getCookie("csrftoken")||await getCsrf();
      const res=await fetch("/refresh/",{
        method:"POST",
        credentials:"include",
        headers:{"X-CSRFToken":csrf},
      });
      return res.ok;
    }catch{
      return false;
    }
  },[getCsrf]);

  const loadUser=useCallback(async()=>{
    try{
      let res=await fetch("/me/",{credentials:"include"});

      if(res.status===401){
        const refreshed=await refresh();
        if(!refreshed){
          setUser(null);
          return null;
        }
        res=await fetch("/me/",{credentials:"include"});
      }

      if(!res.ok){
        setUser(null);
        return null;
      }

      const data=await res.json();
      setUser(data.user);
      return data.user;
    }catch{
      setUser(null);
      return null;
    }
  },[refresh]);

  useEffect(()=>{
    const init=async()=>{
      await getCsrf().catch(()=>null);
      await loadUser();
      setLoading(false);
    };
    init();
  },[getCsrf,loadUser]);

  const login=async(correo,password)=>{
    const csrf=getCookie("csrftoken")||await getCsrf();
    const res=await fetch("/login/",{
      method:"POST",
      credentials:"include",
      headers:{
        "Content-Type":"application/json",
        "X-CSRFToken":csrf,
      },
      body:JSON.stringify({correo,password}),
    });

    let data={};
    try{
      data=await res.json();
    }catch{
      throw new Error("Servidor no respondió correctamente");
    }

    if(!res.ok) throw new Error(data.error||"Credenciales incorrectas");

    setUser(data.user);
    return data.user;
  };

  const logout=async()=>{
    try{
      const csrf=getCookie("csrftoken")||await getCsrf();
      await fetch("/logout/",{
        method:"POST",
        credentials:"include",
        headers:{"X-CSRFToken":csrf},
      });
    }finally{
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{user,loading,isAuthenticated:Boolean(user),login,logout,refresh,loadUser}}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(){
  const context=useContext(AuthContext);
  if(!context) throw new Error("useAuth debe usarse dentro de AuthProvider");
  return context;
}